import { MeasureTheItemQuestion } from '~/types/bootcamp'

import { getRandomInt } from '~/bootcamp/Activities/Fractions/Fractions.utils'

import { MeasureTheItemActivityData } from './MeasureTheItem.type'

/**
 * Chooses question for the activity
 * @param questions all available multiple choice question
 * @param history previously selected question history
 * @returns multiple choice activity data
 */
export function generateMeasureTheItemActivityData(
  questions: MeasureTheItemQuestion[],
  history: number[],
): MeasureTheItemActivityData {
  const questionIndex = getRandomInt(0, questions.length - 1, history)
  const question = questions[questionIndex]

  return { questionIndex, question }
}
